import classNames from 'classnames';
import DOMPurify from 'dompurify';
import React, { useState } from 'react';
import Arrow from './Arrow';
import { ReactComponent as IconMinus } from '../../assets/icons/icon-minus.svg';
import { ReactComponent as IconPlus } from '../../assets/icons/icon-plus.svg';

export type ToggleItem = {
  children: string | React.ReactNode;
  title: string;
};

interface Props {
  items: ToggleItem[];
  style?: 'rounded' | 'flat';
}

const Toggle: React.FC<Props> = ({ items = [], style = 'rounded' }) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  return (
    <div className={classNames('toggle', style)}>
      {items.map((item, index) => {
        return (
          <div
            key={index}
            className={classNames({
              'toggle-item': true,
              active: activeIndex === index,
            })}
          >
            <div
              className="toggle-item-title-wrapper"
              onClick={() => {
                setActiveIndex(index);
              }}
            >
              <div className="toggle-item-title-text">{item.title}</div>
              <div className="toggle-item-title-button">
                {activeIndex === index &&
                  (style === 'rounded' ? <Arrow direction="up" /> : <IconMinus />)}
                {activeIndex !== index &&
                  (style === 'rounded' ? <Arrow direction="down" /> : <IconPlus />)}
              </div>
            </div>
            {typeof item.children === 'string' && (
              <div
                className="toggle-item-content"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(item.children),
                }}
              ></div>
            )}
            {typeof item.children !== 'string' && (
              <div className="toggle-item-content">{item.children}</div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Toggle;
